import api from './client';

export interface Tenant {
  id: string;
  name: string;
  slug: string;
  my_role: string;  // owner / admin / member
  member_count: number;
  max_users: number;
  is_active: boolean;
}

export interface TenantMember {
  user_id: string;
  email: string;
  name?: string | null;
  role: string;
  created_at: string;
}

export interface TenantAuditEntry {
  id: string;
  actor_user_id: string;
  actor_email?: string | null;
  action: string;  // tenant_create / member_add / member_remove / content_create / content_delete
  target_type: string;  // member / note / knowledge / clip / tenant
  target_id?: string | null;
  detail?: string | null;
  created_at: string;
}

// 数据口径由服务端按 user.tenant_id（激活租户）自动切换，请求无需带任何租户参数
export const tenantsApi = {
  list: () => api.get<Tenant[]>('/api/v1/tenants/me'),
  create: (name: string) => api.post<{ id: string; name: string; slug: string; my_role: string }>('/api/v1/tenants', { name }),
  activate: (id: string) => api.post(`/api/v1/tenants/${id}/activate`),
  deactivate: () => api.post('/api/v1/tenants/deactivate'),
  listMembers: (id: string) => api.get<TenantMember[]>(`/api/v1/tenants/${id}/members`),
  addMember: (id: string, data: { email: string; role: string }) =>
    api.post<TenantMember>(`/api/v1/tenants/${id}/members`, data),
  removeMember: (id: string, userId: string) => api.delete(`/api/v1/tenants/${id}/members/${userId}`),
  listAudit: (id: string, limit = 50) => api.get<TenantAuditEntry[]>(`/api/v1/tenants/${id}/audit`, { params: { limit } }),
};
